export const domainsThatDisplayMastertrackCarousels = ['business', 'computer-science'];
